import { user } from './auth/user';

export const getBlobFromDataUrl = (dataUrl: string): Blob => {
  const [prefix, base64] = dataUrl.split(',');
  const mime = prefix.match(/:(.*?);/)?.[1] ?? 'image/png';
  const binary = atob(base64);
  const array = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    array[i] = binary.charCodeAt(i);
  }
  return new Blob([array], { type: mime });
};

export const getCurrentDealerId = (brand: string): string => {
  if (!brand) {
    return '';
  }
  // Leniency for integrators that might not have dealerIdsList set properly
  const allDealerIds = [user.dealerId, ...(user.dealerIdsList ?? [''])];
  return allDealerIds.find((str) => str?.endsWith(brand)) ?? '';
};
